import axios from "axios";
import { OutputBaseProps } from "utils/types/API";
import { FileItemProps } from ".";
import { store } from "store";
import { upload } from "store/file";

export interface ApiFileUploadInputProps {
    files: FileList[];
    folderId?: number;
}

export type ApiFileUploadOutputProps = OutputBaseProps<{ list: FileItemProps[] }>;

export const apiFileUpload = async (input: ApiFileUploadInputProps) => {
    const files = Array.from(input.files);
    const formData = new FormData();
    input.folderId && input.folderId !== -1 && formData.append("folderId", input.folderId.toString());

    files.forEach((file: any) => {
        formData.append("files[]", file); // <- đổi thành files[]
    });

    const res = (
        await axios.post<ApiFileUploadOutputProps>("/api/file/upload", formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        })
    ).data;
    if (res.code === 0 && res.data) {
        store.dispatch(upload({ data: res.data.list, folderId: input.folderId }));
    }
    return res;
};

